var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com2",class:{'bor': _vm.bor===true}},[_vm._v("\n    我是组件2\n")])}
var staticRenderFns = []

export { render, staticRenderFns }